import { render, staticRenderFns } from "./AdminWorkshopOrdersEditScreen.vue?vue&type=template&id=0182165d&scoped=true&"
import script from "./AdminWorkshopOrdersEditScreen.vue?vue&type=script&lang=js&"
export * from "./AdminWorkshopOrdersEditScreen.vue?vue&type=script&lang=js&"
import style0 from "./AdminWorkshopOrdersEditScreen.vue?vue&type=style&index=0&id=0182165d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0182165d",
  null
  
)

export default component.exports